import React from "react";
import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { ProductsFilters } from "./ProductsFilters";
import { ProductsList } from "./ProductsList";
import { ProductsVerify } from "./ProductsVerify";


const initialFilter = {
  filter: {

  },
  sortOrder: "asc",
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
};


export function ProductsListCard({history}) {
  const [queryParams, setQueryParams] = useState(initialFilter);
  const [activeTab, setActiveTab] = useState('productos');

  const viewProduct = (row)=>{
      history.push(`/inventario/productos/${row.id}`);
  }

  return (
    <Card>
      <CardHeader title="Lista de Productos">
        <CardHeaderToolbar>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-5"
        >
          <Tab eventKey="productos" title="Productos">
            <ProductsFilters setQueryParams={setQueryParams}  queryParams={queryParams}/>
            <ProductsList viewProduct={viewProduct}   queryParams={queryParams} setQueryParams={setQueryParams}/>
          </Tab>
          <Tab eventKey="verificacion" title="Verificación">
            <ProductsVerify activeTab={activeTab} />
          </Tab>
        </Tabs>
      </CardBody>
    </Card>
  );
}
